import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const name = localStorage.getItem("tf_user");
    const token = localStorage.getItem("tf_token");
    const role = localStorage.getItem("tf_role") || "titolare";
    const storeId = localStorage.getItem("tf_store_id") || null;
    return name && token ? { name, token, role, storeId } : null;
  });
  const [ready] = useState(true);

  const login = useCallback(async (userName, password, role = "titolare", storeId = null) => {
    const payload = { user_name: userName, password, role };
    if (role === "direttore") payload.store_id = storeId;
    const { data } = await api.post("/auth/login", payload);
    localStorage.setItem("tf_token", data.token);
    localStorage.setItem("tf_user", data.user_name);
    localStorage.setItem("tf_role", data.role);
    if (data.store_id) localStorage.setItem("tf_store_id", data.store_id);
    else localStorage.removeItem("tf_store_id");
    setUser({ name: data.user_name, token: data.token, role: data.role, storeId: data.store_id });
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("tf_token");
    localStorage.removeItem("tf_user");
    localStorage.removeItem("tf_role");
    localStorage.removeItem("tf_store_id");
    setUser(null);
  }, []);

  const isTitolare = user?.role === "titolare";
  const isDirettore = user?.role === "direttore";
  const canAccessStore = useCallback(
    (storeId) => user?.role === "titolare" || user?.storeId === storeId,
    [user]
  );

  const value = useMemo(
    () => ({ user, login, logout, ready, isTitolare, isDirettore, canAccessStore }),
    [user, login, logout, ready, isTitolare, isDirettore, canAccessStore]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
